export default __webpack_public_path__ + "static/media/Storm_Blue.f8d552fe.webp";